module.exports = __webpack_public_path__ + "static/img8-7c9fd4612c550e02160755247142af44.jpg";